import React from 'react';
import { Switch, Route } from 'react-router-dom';
import ScheduleTwoForm from './scheduleTwoForm';

const ControlsRouter = props => (
  <Switch>
    <Route exact path="/controls" component={ScheduleTwoForm} />
  </Switch>
);

export default ControlsRouter;
